import React from "react";
import "./Footer.scss";

export default function Footer() {
  return (
    <>
      <br />
      <div className="footer">
        Made with &nbsp; &nbsp;
        <i className="heart"></i>
        &nbsp; &nbsp; by aminos
      </div>
    </>
  );
}
